import { Component, Injector, forwardRef } from '@angular/core';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-product-field-date',
  templateUrl: './product-field-date.component.html',
  styleUrls: ['./product-field-date.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldDateComponent),
      multi: true,
    },
  ],
})
export class ProductFieldDateComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor
{
  value: Date | null = null;
  constructor(injector: Injector) {
    super(injector);
  }

  //onChange: any = (value: string | Date) => {};
  // onTouched: any = () => {};
  onChange: (value: Date | null) => void = () => {};
  onTouched: () => void = () => {};
 
  writeValue(value: any): void {
    if (value == null || value === '') {
      this.value = null;
     // return;
    }
    if (typeof value === 'string') {
      this.value = new Date(value);
     // this.value = JSON.parse(value);
    } else {
      this.value = value;
    }
    //this.onChange(this.value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  onDateChange(date: Date | null): void {
    this.value = date;
    this.onChange(this.value); 
  }
}
